import { jsxs as r, jsx as l } from "react/jsx-runtime";
const v = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M49.383 10.847V8.6H14.617v2.247H6.221V23.37c0 5.442 4.312 9.895 9.699 10.122 2.359 5.732 7.693 9.925 14.08 10.657v7.412H19.35v4h25.3v-4H34V44.15c6.384-.731 11.716-4.92 14.077-10.649 5.52-.078 9.986-4.592 9.986-10.13V10.847h-8.68ZM10.22 23.37v-8.524h4.396v12.036c0 .82.059 1.626.168 2.416a6.142 6.142 0 0 1-4.564-5.928Zm35.162 3.512c0 3.575-1.393 6.935-3.92 9.463A13.295 13.295 0 0 1 32 40.266a13.295 13.295 0 0 1-9.463-3.92 13.295 13.295 0 0 1-3.92-9.463V12.6h26.765v14.283Zm8.68-3.512c0 2.945-2.086 5.41-4.858 5.998a17.53 17.53 0 0 0 .178-2.486V14.847h4.68v8.524Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M25.793 33.918 32 31.083l6.207 2.835-1.186-6.394 4.63-3.972-6.548-1.831L32 16.286l-3.104 5.435-6.548 1.829 4.63 3.974-1.185 6.394Zm.697-9.448 2.945-.823.79-.22.408-.715L32 20.32l1.366 2.393.408.714.79.22 2.945.824-1.79 1.536-.874.75.21 1.133.484 2.612-2.708-1.238-.831-.38-.831.38-2.708 1.238.484-2.612.21-1.132-.874-.75-1.79-1.537Z"
        }
      )
    ]
  }
);
export {
  v as Competition
};
